// src/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './features/auth/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  // Display loading state while checking authentication status
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to login if the user is not logged in
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children; // Render the child components if authenticated
};

export default ProtectedRoute;
